import MobileImage from "../../assets/images/image-web-3-mobile.jpg";
import WebImage from "../../assets/images/image-web-3-desktop.jpg";
import { useMediaQuery } from "react-responsive";
import "./index.scss";
export default function WebFuture() {
  const isDesktop = useMediaQuery({
    query: "(min-width: 1920px)",
  });
  return (
    <>
      <div className="web">
        <div className="web__image">
          <img src={isDesktop ? WebImage : MobileImage} />
        </div>
        <p className="web__title">The Bright Future of Web 3.0?</p>
        <p className="web__paragraph">
          We dive the next evolution of web that claims to put the power of
          platforms back into the hands of the people. But is it really
          fulfilling its promise?
        </p>
        <div className="web__btn__readmore">
          <button>Read More</button>
        </div>
      </div>
    </>
  );
}
